import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchProductOffers = createAsyncThunk(
  "offers/fetchProductOffers",
  async ({ lang, page = 1 }, { rejectWithValue }) => {
    try {
      //console.log('=== Fetching Product Offers ===');
      //console.log('Language:', lang);
      //console.log('Page:', page);
      
      const response = await axios.get(`${BASE_URL}/products/offers`, {
        headers: {
          "Accept-Language": lang || "en",
        },
        params: {
          page,
          per_page: 10, 
        },
      });

      //console.log('=== Product Offers API Response ===');
      //console.log('Full response:', response);
      //console.log('Response data:', response.data);
      //console.log('Response data.data:', response.data.data);
      //console.log('Response pagination:', response.data.pagination);

      return {
        data: response.data.data,
        pagination: response.data.pagination,
      };
    } catch (error) {
      console.error('=== Product Offers API Error ===');
      console.error('Error:', error);
      console.error('Error response:', error.response);
      console.error('Error response data:', error.response?.data);
      
      const message =
        error.response?.data?.message || "Failed to fetch product offers";
      return rejectWithValue({ message });
    }
  }
);
